// C1-INT - Ünite 1: İleri Behavioral Sorular
// Gerçekçi mülakat senaryoları ve diyaloglar

export const C1INT_UNIT_1 = {
  'C1INT-U1-L1': {
    id: 'C1INT-U1-L1',
    title: 'Describe a time you showed leadership',
    type: 'interview',
    content: {
      sections: [
        {
          type: 'intro',
          title: '🎯 Bu Soru Neden Sorulur?',
          content: 'Havayolları, özellikle kıdemli pozisyonlar için liderlik potansiyeli arar. Bu soru ile:\n• İnisiyatif alma yeteneğiniz\n• Ekibi yönlendirme beceriniz\n• Sorumluluk alma cesaretiniz\n• Sonuç odaklı olmanız test edilir.'
        },
        {
          type: 'scenario',
          title: '✈️ Mülakat Senaryosu 1: Deneyimli Aday',
          dialogues: [
            {
              speaker: 'Mülakatçı (HR Manager)',
              text: 'Can you describe a situation where you had to take the lead, even if it wasn\'t your official responsibility?',
              translation: 'Resmi sorumluluğunuz olmasa bile liderlik üstlenmeniz gereken bir durumu anlatır mısınız?'
            },
            {
              speaker: 'Aday (Güçlü Cevap)',
              text: 'Certainly. During my time as a hotel receptionist, our night manager suddenly became ill during a fully booked weekend. With no immediate replacement available, I stepped up to coordinate the team of 5 staff members.',
              translation: 'Elbette. Otel resepsiyonistiyken, gece müdürümüz tam dolu bir hafta sonu aniden hastalandı. Hemen yerine kimse bulunamayınca, 5 kişilik ekibi koordine etmek için öne çıktım.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'I delegated tasks based on each person\'s strengths, handled escalated guest complaints personally, and maintained communication with management. By morning, we had resolved two overbooking situations and received three positive guest reviews mentioning our team\'s professionalism.',
              translation: 'Görevleri herkesin güçlü yönlerine göre dağıttım, ciddi misafir şikayetlerini bizzat çözdüm ve yönetimle iletişimi sürdürdüm. Sabaha kadar iki fazla rezervasyon sorununu çözdük ve ekibimizin profesyonelliğinden bahseden üç olumlu misafir yorumu aldık.'
            },
            {
              speaker: 'Mülakatçı',
              text: 'What was the most challenging part of that night?',
              translation: 'O gecenin en zorlu kısmı neydi?'
            },
            {
              speaker: 'Aday',
              text: 'Honestly, it was managing the team\'s stress. Two colleagues were quite anxious about the situation. I made sure to check in with them regularly, acknowledge their efforts, and remind them we were handling it together. Leadership isn\'t just about tasks—it\'s about people.',
              translation: 'Dürüst olmak gerekirse, ekibin stresini yönetmekti. İki meslektaşım durumdan oldukça endişeliydi. Onlarla düzenli olarak görüştüm, çabalarını takdir ettim ve bunu birlikte hallettiğimizi hatırlattım. Liderlik sadece görevlerle ilgili değil—insanlarla ilgili.'
            }
          ]
        },
        {
          type: 'analysis',
          title: '📊 Cevap Analizi',
          content: '✅ **Neden güçlü bir cevap:**\n• Somut bir durum (otel, hafta sonu, müdür hastalığı)\n• Net eylemler (delegasyon, şikayet yönetimi, iletişim)\n• Ölçülebilir sonuç (2 sorun çözüldü, 3 olumlu yorum)\n• Takip sorusuna empati odaklı yanıt\n• "Leadership is about people" - değer ifadesi'
        },
        {
          type: 'scenario',
          title: '❌ Kaçınılması Gereken Cevap',
          dialogues: [
            {
              speaker: 'Mülakatçı',
              text: 'Describe a time you showed leadership.',
              translation: 'Liderlik gösterdiğiniz bir zamanı anlatın.'
            },
            {
              speaker: 'Aday (Zayıf Cevap)',
              text: 'I\'m a natural leader. In my last job, I was always the one people came to for help. I\'m good at telling people what to do and making sure things get done.',
              translation: 'Doğuştan liderim. Son işimde insanlar hep yardım için bana gelirdi. İnsanlara ne yapacaklarını söylemekte ve işlerin yapılmasını sağlamakta iyiyim.'
            }
          ]
        },
        {
          type: 'warning',
          title: '⚠️ Bu Cevabın Sorunları',
          content: '• Somut örnek yok\n• "Telling people what to do" = Otoriter, takım çalışmasına uygun değil\n• Sonuç veya etki belirtilmemiş\n• Kendini övme, kanıt sunmama'
        },
        {
          type: 'tip',
          content: '💡 **Altın Kural:** Havayolları "servant leadership" arar - ekibe hizmet eden, destekleyen lider. "Boss" değil, "leader" olduğunuzu gösterin.'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'Liderlik cevabında hangisi EN ÖNEMLİ?',
          options: [
            'Kaç kişiyi yönettiğinizi söylemek',
            'Somut örnek + eylemler + ölçülebilir sonuç',
            'Ne kadar iyi lider olduğunuzu vurgulamak',
            'Yöneticilerinizin sizi övdüğünü belirtmek'
          ],
          correctIndex: 1,
          explanation: 'STAR metodu: Durum + Görev + Eylem + Sonuç. Somut ve ölçülebilir örnekler her zaman etkilidir.'
        },
        {
          type: 'multipleChoice',
          question: '"Leadership is about people, not just tasks" ifadesi neyi gösterir?',
          options: [
            'Görevleri önemsemediğinizi',
            'Empati ve ekip odaklı liderlik anlayışını',
            'Sadece insanlarla ilgilendiğinizi',
            'Teknik becerilerin önemsiz olduğunu'
          ],
          correctIndex: 1,
          explanation: 'Havayolları empati ve takım çalışmasını vurgulayan liderler arar. Bu ifade servant leadership gösterir.'
        }
      ]
    }
  },

  'C1INT-U1-L2': {
    id: 'C1INT-U1-L2',
    title: 'Tell me about a time you failed and what you learned',
    type: 'interview',
    content: {
      sections: [
        {
          type: 'intro',
          title: '🎯 Bu Soru Neden Sorulur?',
          content: 'Bu soru ile test edilen:\n• Öz farkındalık ve dürüstlük\n• Hatalardan ders çıkarma yeteneği\n• Büyüme zihniyeti (growth mindset)\n• Savunmaya geçmeden eleştiriyi kabul edebilme\n• Profesyonel olgunluk'
        },
        {
          type: 'scenario',
          title: '✈️ Mülakat Senaryosu: Başarısızlıktan Öğrenme',
          dialogues: [
            {
              speaker: 'Mülakatçı (Operations Manager)',
              text: 'Tell me about a time you failed at something. What happened and what did you learn from it?',
              translation: 'Bir şeyde başarısız olduğunuz bir zamanı anlatın. Ne oldu ve bundan ne öğrendiniz?'
            },
            {
              speaker: 'Aday (Güçlü Cevap)',
              text: 'In my first month as a customer service representative, I made a significant mistake. A customer asked about a refund policy, and I gave incorrect information based on what I thought I remembered from training, rather than checking the handbook.',
              translation: 'Müşteri hizmetleri temsilcisi olarak ilk ayımda önemli bir hata yaptım. Bir müşteri iade politikasını sorduğunda, el kitabını kontrol etmek yerine eğitimden hatırladığımı sandığım bilgiyi verdim.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'The customer followed my advice, and when they returned, they discovered my information was wrong. They were understandably upset, and my supervisor had to step in to resolve the situation.',
              translation: 'Müşteri tavsiyemi izledi ve döndüğünde bilgimin yanlış olduğunu keşfetti. Haklı olarak üzgündüler ve amirimin durumu çözmek için devreye girmesi gerekti.'
            },
            {
              speaker: 'Mülakatçı',
              text: 'That sounds difficult. How did you handle the aftermath?',
              translation: 'Bu zor görünüyor. Sonrasını nasıl yönettiniz?'
            },
            {
              speaker: 'Aday',
              text: 'I apologized sincerely to both the customer and my supervisor. Then I asked my supervisor for feedback on how I could have handled it better. I created a quick-reference card for myself with key policies, and I made it a rule to always verify before answering policy questions.',
              translation: 'Hem müşteriden hem amirimin özür diledim. Sonra amirimden durumu nasıl daha iyi yönetebileceğime dair geri bildirim istedim. Kendime temel politikalarla hızlı başvuru kartı hazırladım ve politika sorularını yanıtlamadan önce her zaman doğrulama yapmayı kural edindim.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'Since then, I\'ve had zero policy-related complaints. More importantly, I learned that it\'s okay to say "Let me verify that for you" rather than guessing. Passengers and customers actually appreciate the thoroughness.',
              translation: 'O zamandan beri politikayla ilgili sıfır şikayet aldım. Daha da önemlisi, tahmin etmek yerine "Bunu sizin için doğrulayayım" demenin sorun olmadığını öğrendim. Yolcular ve müşteriler aslında bu titizliği takdir ediyor.'
            }
          ]
        },
        {
          type: 'analysis',
          title: '📊 Cevap Analizi',
          content: '✅ **Neden mükemmel bir cevap:**\n• Gerçek, somut bir hata (yanlış bilgi verme)\n• Sorumluluğu kabul ediyor, başkasını suçlamıyor\n• Aldığı aksiyonlar net (özür, geri bildirim isteme, referans kartı)\n• Kalıcı değişiklik yaptığını gösteriyor\n• Olumlu sonuç belirtiyor (sıfır şikayet)\n• Genel bir ders çıkarıyor ("Let me verify" yaklaşımı)'
        },
        {
          type: 'scenario',
          title: '❌ Kaçınılması Gereken Cevaplar',
          dialogues: [
            {
              speaker: 'Kötü Cevap 1',
              text: 'I can\'t think of any failures. I\'m usually very careful and thorough in everything I do.',
              translation: 'Hiçbir başarısızlık aklıma gelmiyor. Genellikle yaptığım her şeyde çok dikkatli ve titizimdir.'
            },
            {
              speaker: 'Kötü Cevap 2',
              text: 'Once my team failed to meet a deadline, but it was mostly because my colleagues didn\'t pull their weight.',
              translation: 'Bir kez ekibim bir teslim tarihini kaçırdı, ama bu çoğunlukla meslektaşlarımın üzerine düşeni yapmamasındandı.'
            },
            {
              speaker: 'Kötü Cevap 3',
              text: 'I failed a university exam once, but I retook it and passed.',
              translation: 'Bir keresinde üniversite sınavından kaldım ama tekrar girdim ve geçtim.'
            }
          ]
        },
        {
          type: 'warning',
          title: '⚠️ Bu Cevapların Sorunları',
          content: '**Cevap 1:** Samimiyetsiz görünür, kimse hatasız değil\n**Cevap 2:** Başkalarını suçluyor, sorumluluk almıyor\n**Cevap 3:** Profesyonel olmayan örnek, iş hayatından seçilmeli'
        },
        {
          type: 'tip',
          content: '💡 **Altın Kural:** "Failure" sorusunda 3 şey gösterin:\n1. Dürüstlük (gerçek bir hata)\n2. Sorumluluk (suçlamadan kabul)\n3. Büyüme (somut ders ve değişiklik)'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'Başarısızlık sorusunda EN TEHLİKELİ cevap:',
          options: [
            'Küçük ama gerçek bir hata anlatmak',
            '"Başarısızlık yaşamadım" demek',
            'Hatadan ne öğrendiğini anlatmak',
            'Sonrasında ne değiştiğini belirtmek'
          ],
          correctIndex: 1,
          explanation: '"Başarısızlık yaşamadım" demek ya yalan söylediğinizi ya da öz farkındalığınızın düşük olduğunu gösterir.'
        },
        {
          type: 'multipleChoice',
          question: 'Hangisi profesyonel olmayan bir başarısızlık örneği?',
          options: [
            'Müşteriye yanlış bilgi vermek',
            'Bir toplantıya geç kalmak',
            'Üniversite sınavından kalmak',
            'Bir projeyi zamanında teslim edememek'
          ],
          correctIndex: 2,
          explanation: 'İş mülakatında iş hayatından örnekler kullanın. Akademik veya kişisel örnekler profesyonel olgunluk göstermez.'
        }
      ]
    }
  },

  'C1INT-U1-L3': {
    id: 'C1INT-U1-L3',
    title: 'How do you prioritize under pressure?',
    type: 'interview',
    content: {
      sections: [
        {
          type: 'intro',
          title: '🎯 Bu Soru Neden Sorulur?',
          content: 'Kabin memurluğu sürekli baskı altında çalışmaktır:\n• Kısa turnaround süreleri\n• Aynı anda birden fazla talep\n• Acil durumlar\n• Zor yolcular\n• Jet lag ve yorgunluk\n\nBu soru, stres altında mantıklı kararlar verme yeteneğinizi ölçer.'
        },
        {
          type: 'scenario',
          title: '✈️ Mülakat Senaryosu: Baskı Altında Önceliklendirme',
          dialogues: [
            {
              speaker: 'Mülakatçı',
              text: 'Imagine you\'re working during a busy service. Multiple passengers press their call buttons at once, a colleague needs help, and you notice a child crying. How do you prioritize?',
              translation: 'Yoğun bir servis sırasında çalıştığınızı hayal edin. Birden fazla yolcu aynı anda çağrı butonuna basıyor, bir meslektaşınızın yardıma ihtiyacı var ve ağlayan bir çocuk fark ediyorsunuz. Nasıl öncelik sırası yaparsınız?'
            },
            {
              speaker: 'Aday (Güçlü Cevap)',
              text: 'Great question. My approach would be to quickly assess urgency levels. First, I\'d make brief eye contact with each passenger who pressed the call button and give a reassuring nod to acknowledge them - this shows I\'ve seen them and prevents frustration from building.',
              translation: 'Harika soru. Yaklaşımım aciliyet seviyelerini hızlıca değerlendirmek olurdu. Önce, çağrı butonuna basan her yolcuyla kısa göz teması kurar ve onları gördüğümü belirten rahatlatıcı bir baş selamı verirdim - bu, onları gördüğümü gösterir ve hayal kırıklığının birikmesini önler.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'Then I\'d check on my colleague briefly - if it\'s a safety issue, that takes priority. If not, I\'d ask them to give me 30 seconds.',
              translation: 'Sonra kısaca meslektaşımı kontrol ederdim - eğer güvenlik sorunuysa, o öncelik alır. Değilse, bana 30 saniye vermesini isterdim.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'Next, I\'d address the passengers in order of urgency - medical concern first, then comfort requests. For the crying child, I\'d catch the parent\'s eye and offer a warm smile or quick assistance depending on the situation.',
              translation: 'Ardından, yolcuları aciliyet sırasına göre ilgilendirirdim - önce tıbbi endişe, sonra konfor talepleri. Ağlayan çocuk için, ebeveynin gözünü yakalayıp duruma göre sıcak bir gülümseme veya hızlı yardım sunardım.'
            },
            {
              speaker: 'Mülakatçı',
              text: 'What if two passengers both claim their issue is urgent?',
              translation: 'Ya iki yolcu da sorunlarının acil olduğunu iddia ederse?'
            },
            {
              speaker: 'Aday',
              text: 'I\'d trust my training to identify genuine urgency - medical symptoms, distress signals. For equally non-urgent issues, I\'d help the first person quickly while acknowledging the second: "I\'ll be with you in just a moment, thank you for your patience." Clear communication prevents escalation.',
              translation: 'Gerçek aciliyeti belirlemek için eğitimime güvenirdim - tıbbi belirtiler, sıkıntı sinyalleri. Eşit derecede acil olmayan sorunlar için, ikinciyi kabul ederek ilk kişiye hızlıca yardım ederdim: "Bir dakika içinde sizinle ilgileneceğim, sabrınız için teşekkür ederim." Net iletişim tırmanmayı önler.'
            }
          ]
        },
        {
          type: 'framework',
          title: '📋 Önceliklendirme Çerçevesi',
          content: '**Kabin memurluğunda öncelik sırası:**\n\n🔴 **1. Güvenlik (Safety)** - Her şeyden önce\n• Tıbbi acil durum\n• Güvenlik tehdidi\n• Ekipman arızası\n\n🟠 **2. Güvenlik (Security)** - İkinci öncelik\n• Şüpheli davranış\n• Düzenleyici gereklilikler\n\n🟢 **3. Hizmet (Service)** - Üçüncü öncelik\n• Yolcu konforu\n• İkram hizmetleri'
        },
        {
          type: 'scenario',
          title: '❌ Zayıf Cevap Örneği',
          dialogues: [
            {
              speaker: 'Aday (Zayıf)',
              text: 'I would just handle things one at a time and try to stay calm. I\'m pretty good under pressure.',
              translation: 'Her şeyi teker teker halleder ve sakin kalmaya çalışırdım. Baskı altında oldukça iyiyimdir.'
            }
          ]
        },
        {
          type: 'warning',
          title: '⚠️ Sorunlar',
          content: '• Somut strateji yok\n• "One at a time" = Önceliklendirme yapmıyor\n• "Pretty good" = Belirsiz, kanıtsız\n• Sistemik düşünce göstermiyor'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'Kabin memurluğunda en yüksek öncelik:',
          options: ['Yolcu konforu', 'Güvenlik (Safety)', 'Hizmet kalitesi', 'Zaman yönetimi'],
          correctIndex: 1,
          explanation: 'Havacılıkta altın kural: Safety > Security > Service'
        },
        {
          type: 'multipleChoice',
          question: 'Birden fazla yolcu aynı anda yardım istediğinde ilk yapılması gereken:',
          options: [
            'Hepsini sırayla görmezden gelmek',
            'En yakındakine yardım etmek',
            'Herkesi göz temasıyla onaylamak, sonra aciliyete göre sıralamak',
            'Meslektaşı çağırmak'
          ],
          correctIndex: 2,
          explanation: 'Göz teması onaylama sağlar ve bekleme stresini azaltır. Sonra aciliyet değerlendirmesi yapılır.'
        }
      ]
    }
  },

  'C1INT-U1-L4': {
    id: 'C1INT-U1-L4',
    title: 'Describe your biggest professional achievement',
    type: 'interview',
    content: {
      sections: [
        {
          type: 'intro',
          title: '🎯 Bu Soru Neden Sorulur?',
          content: 'Bu soru ile değerlendirilen:\n• Neyi başarı olarak gördüğünüz (değerleriniz)\n• Sonuç üretme kapasiteniz\n• Takım mı bireysel mi odaklısınız\n• Gurur duyduğunuz şeylerin havayolu kültürüyle uyumu'
        },
        {
          type: 'scenario',
          title: '✈️ Mülakat Senaryosu: En Büyük Başarı',
          dialogues: [
            {
              speaker: 'Mülakatçı',
              text: 'What would you say is your proudest professional achievement?',
              translation: 'En gurur duyduğunuz profesyonel başarınız nedir dersiniz?'
            },
            {
              speaker: 'Aday (Güçlü Cevap)',
              text: 'My proudest achievement was turning around a struggling customer satisfaction score in my previous role. When I joined the front desk team, our guest satisfaction was at 72%, well below the company target of 85%.',
              translation: 'En gurur duyduğum başarı, önceki görevimde düşük bir müşteri memnuniyet puanını iyileştirmekti. Resepsiyon ekibine katıldığımda, misafir memnuniyetimiz %72\'deydi, şirket hedefi olan %85\'in oldukça altında.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'I started collecting informal feedback from guests to understand the real issues. It turned out small things mattered most - greeting by name, remembering preferences, proactive offers. I shared these insights with my team and we created a "guest memory" system where we noted details for returning visitors.',
              translation: 'Gerçek sorunları anlamak için misafirlerden gayri resmi geri bildirim toplamaya başladım. Küçük şeylerin en çok önemli olduğu ortaya çıktı - isimle selamlama, tercihleri hatırlama, proaktif teklifler. Bu içgörüleri ekibimle paylaştım ve geri dönen ziyaretçiler için ayrıntıları not aldığımız bir "misafir hafızası" sistemi oluşturduk.'
            },
            {
              speaker: 'Mülakatçı',
              text: 'What were the results?',
              translation: 'Sonuçlar ne oldu?'
            },
            {
              speaker: 'Aday',
              text: 'Within six months, our satisfaction score rose to 89%, and it stayed above 85% after I left. More importantly, my manager adopted the system across all three hotel locations. What made me proudest wasn\'t the number—it was seeing my colleagues genuinely excited about creating better guest experiences.',
              translation: 'Altı ay içinde memnuniyet puanımız %89\'a yükseldi ve ben ayrıldıktan sonra da %85\'in üzerinde kaldı. Daha da önemlisi, müdürüm sistemi üç otel lokasyonuna da uyarladı. Beni en çok gururlandıran rakam değildi—meslektaşlarımın daha iyi misafir deneyimleri yaratma konusunda gerçekten heyecanlı olduğunu görmekti.'
            }
          ]
        },
        {
          type: 'analysis',
          title: '📊 Neden Mükemmel Bir Cevap',
          content: '✅ **Güçlü yönler:**\n• Ölçülebilir başlangıç noktası (%72) ve sonuç (%89)\n• Kalıcı etki (ayrıldıktan sonra da devam)\n• Ekip başarısı olarak sunuyor (bireysel ego değil)\n• Sistemik düşünce (süreç oluşturma)\n• Duygusal zeka (meslektaşların heyecanı)\n• Havayolu kültürüyle uyumlu (müşteri odaklılık)'
        },
        {
          type: 'scenario',
          title: '❌ Kaçınılması Gereken Cevaplar',
          dialogues: [
            {
              speaker: 'Kötü Cevap 1',
              text: 'Getting hired for this interview is my biggest achievement!',
              translation: 'Bu mülakata çağrılmak en büyük başarım!'
            },
            {
              speaker: 'Kötü Cevap 2',
              text: 'I was employee of the month three times.',
              translation: 'Üç kez ayın çalışanı seçildim.'
            },
            {
              speaker: 'Kötü Cevap 3',
              text: 'I single-handedly saved a project when my whole team failed.',
              translation: 'Tüm ekibim başarısız olduğunda tek başıma bir projeyi kurtardım.'
            }
          ]
        },
        {
          type: 'warning',
          title: '⚠️ Sorunlar',
          content: '**Cevap 1:** Yağcılık, samimiyetsiz\n**Cevap 2:** Detaysız, ne için verildi belli değil\n**Cevap 3:** Takım karşıtı, kibir gösterir'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'Başarı hikayesinde hangisi EN ÖNEMLİ?',
          options: [
            'Ne kadar zor olduğunu vurgulamak',
            'Ölçülebilir sonuç ve kalıcı etki göstermek',
            'Tek başına yaptığınızı belirtmek',
            'Yöneticilerin sizi övdüğünü söylemek'
          ],
          correctIndex: 1,
          explanation: 'Sayısal sonuçlar ve uzun vadeli etki, başarının gerçekliğini kanıtlar.'
        }
      ]
    }
  },

  'C1INT-U1-L5': {
    id: 'C1INT-U1-L5',
    title: 'Pratik: Liderlik Örnekleri',
    type: 'practice',
    content: {
      sections: [
        {
          type: 'intro',
          title: '🎭 Tam Mülakat Provası',
          content: 'Bu derste, Ünite 1\'de öğrendiğiniz tüm behavioral soruları içeren tam bir mülakat senaryosu göreceksiniz. Her sorudan sonra ideal cevabı analiz edin.'
        },
        {
          type: 'scenario',
          title: '✈️ Tam Mülakat Simülasyonu - Turkish Airlines HR',
          dialogues: [
            {
              speaker: 'HR Manager',
              text: 'Welcome! Let\'s start with a challenging question. Can you describe a situation where you had to lead a team through a difficult period?',
              translation: 'Hoş geldiniz! Zorlu bir soruyla başlayalım. Bir ekibi zor bir dönemden geçirmeniz gereken bir durumu anlatır mısınız?'
            },
            {
              speaker: 'Aday',
              text: 'Thank you for having me. Yes, I can share a recent example. Last year during the peak holiday season, our restaurant was severely understaffed due to a flu outbreak. Three team members called in sick on our busiest night.',
              translation: 'Beni kabul ettiğiniz için teşekkürler. Evet, yakın tarihli bir örnek paylaşabilirim. Geçen yıl yoğun tatil sezonunda, grip salgını nedeniyle restoranımız ciddi personel eksikliği yaşadı. En yoğun gecemizde üç ekip üyesi hasta olduğunu bildirdi.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'As the senior server, I stepped up to coordinate. First, I called two off-duty colleagues who agreed to come in. Then I reorganized our sections, taking the largest one myself. I also simplified our workflow—for example, we pre-set tables and prepared a limited menu to reduce kitchen pressure.',
              translation: 'Kıdemli garson olarak koordine etmek için öne çıktım. Önce, gelmeyi kabul eden iki izinli meslektaşımı aradım. Sonra bölümlerimizi yeniden düzenledim, en büyüğünü kendim aldım. Ayrıca iş akışımızı basitleştirdim—örneğin, masaları önceden hazırladık ve mutfak baskısını azaltmak için sınırlı menü hazırladık.'
            },
            {
              speaker: 'HR Manager',
              text: 'How did your team respond to the changes?',
              translation: 'Ekibiniz değişikliklere nasıl tepki verdi?'
            },
            {
              speaker: 'Aday',
              text: 'Initially there was some stress, but I made sure to check in with everyone regularly and acknowledge their extra effort. I said things like "I know this is tough, and I really appreciate you being here." By the end of the night, we had served 140 covers with only one minor complaint—and the team actually felt proud of what we accomplished together.',
              translation: 'Başlangıçta biraz stres vardı, ancak herkesle düzenli olarak görüşmeyi ve ekstra çabalarını takdir etmeyi sağladım. "Bunun zor olduğunu biliyorum ve burada olduğunuz için gerçekten minnettarım" gibi şeyler söyledim. Gecenin sonunda, sadece bir küçük şikayetle 140 kişiye hizmet verdik—ve ekip aslında birlikte başardıklarımızla gurur duydu.'
            },
            {
              speaker: 'HR Manager',
              text: 'Now, tell me about a time you failed at something.',
              translation: 'Şimdi, bir şeyde başarısız olduğunuz bir zamanı anlatın.'
            },
            {
              speaker: 'Aday',
              text: 'Early in my career, I underestimated the importance of communication. During a hotel event, I changed a setup arrangement without informing my supervisor because I thought it would be more efficient. It turned out the original setup was specifically requested by the client.',
              translation: 'Kariyerimin başlarında, iletişimin önemini hafife aldım. Bir otel etkinliğinde, daha verimli olacağını düşündüğüm için amirimi bilgilendirmeden bir düzenlemeyi değiştirdim. Orijinal düzenlemenin müşteri tarafından özellikle talep edildiği ortaya çıktı.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'My supervisor had to apologize to the client and quickly rearrange everything. I felt terrible. Afterward, I apologized to both my supervisor and the team. From that day, I made it a rule to always communicate changes, no matter how small. Now I actually over-communicate—I\'d rather share too much than too little.',
              translation: 'Amirim müşteriden özür dilemek ve her şeyi hızla yeniden düzenlemek zorunda kaldı. Kendimi çok kötü hissettim. Sonra hem amirimden hem ekipten özür diledim. O günden itibaren, ne kadar küçük olursa olsun değişiklikleri her zaman iletmeyi kural edindim. Şimdi aslında fazla iletişim kuruyorum—çok az yerine çok fazla paylaşmayı tercih ederim.'
            },
            {
              speaker: 'HR Manager',
              text: 'Excellent self-awareness. Final question: What\'s your proudest achievement?',
              translation: 'Mükemmel öz farkındalık. Son soru: En gurur duyduğunuz başarınız nedir?'
            },
            {
              speaker: 'Aday',
              text: 'I\'m most proud of mentoring a colleague who was struggling. She was considering leaving the company because she felt overwhelmed. I spent time understanding her challenges and helped her develop better organizational systems. Six months later, she was promoted to supervisor—and she still sends me updates about her career. Seeing someone grow because you believed in them... that\'s more meaningful than any personal award.',
              translation: 'Zorlanan bir meslektaşıma mentorluk yapmaktan en çok gurur duyuyorum. Bunalmış hissettiği için şirketten ayrılmayı düşünüyordu. Zorluklarını anlamak için zaman harcadım ve daha iyi organizasyon sistemleri geliştirmesine yardım ettim. Altı ay sonra yönetici pozisyonuna terfi etti—ve hâlâ bana kariyer güncellemeleri gönderiyor. Birinin ona inandığınız için büyüdüğünü görmek... bu herhangi bir kişisel ödülden daha anlamlı.'
            }
          ]
        },
        {
          type: 'summary',
          title: '📊 Bu Mülakatın Analizi',
          content: '**✅ Aday şunları gösterdi:**\n• STAR metodunu doğal kullanım\n• Liderlik: Koordinasyon + empati + sonuç\n• Başarısızlık: Dürüstlük + sorumluluk + öğrenme\n• Başarı: Başkalarını geliştirme (servant leadership)\n• Profesyonel olgunluk ve öz farkındalık'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'Bu mülakatta adayın en güçlü özelliği:',
          options: [
            'Çok konuşması',
            'Her cevapta somut örnekler ve sonuçlar vermesi',
            'Kendini çok övmesi',
            'Mülakatçıya soru sorması'
          ],
          correctIndex: 1,
          explanation: 'Her cevap somut örnek, net eylemler ve ölçülebilir sonuçlar içeriyor.'
        }
      ]
    }
  },

  'C1INT-U1-EXAM': {
    id: 'C1INT-U1-EXAM',
    title: 'Unit 1 Exam: Leadership Questions',
    type: 'exam',
    content: {
      timeLimit: 25,
      passingScore: 80,
      questions: [
        {
          type: 'multipleChoice',
          question: 'When answering a leadership question, what is the MOST IMPORTANT element?',
          options: [
            'Mentioning how many people you managed',
            'Specific situation + actions + team impact + results',
            'Stating that you had a formal leadership position',
            'Emphasizing that you were better than everyone else'
          ],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: 'Which is the WORST answer to "Tell me about a failure"?',
          options: [
            'I made a communication error and learned from it',
            'I have never experienced failure, I am very careful',
            'I gave wrong information to a customer and changed my system',
            'I couldn\'t finish a project on time and learned project management'
          ],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: 'In airline interviews, what does "servant leadership" mean?',
          options: [
            'Acting like a servant',
            'A leader who serves, supports, and develops the team',
            'Doing everything alone',
            'Being a boss who gives orders'
          ],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: 'When answering prioritization under pressure questions, what should you demonstrate?',
          options: [
            'I handle it somehow without panicking',
            'Systematic evaluation with Safety > Security > Service priority',
            'I do everything at the same time',
            'I delegate to colleagues'
          ],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: 'What should you AVOID in your greatest achievement answer?',
          options: [
            'Giving measurable results',
            'Presenting it as a team achievement',
            'Saying "I single-handedly saved the entire team"',
            'Mentioning the lasting impact'
          ],
          correctIndex: 2
        },
        {
          type: 'multipleChoice',
          question: 'Which phrase best demonstrates collaborative leadership?',
          options: [
            'I told everyone what to do',
            'I worked with the team to find the best solution',
            'I made all decisions myself',
            'I knew better than my colleagues'
          ],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: 'How should you describe handling conflict between team members?',
          options: [
            'I ignored it until it resolved itself',
            'I took one person\'s side',
            'I facilitated a discussion and helped find common ground',
            'I reported them to management'
          ],
          correctIndex: 2
        }
      ]
    }
  }
};

export default C1INT_UNIT_1;
